import React, { useMemo } from "react";
import styles from "./Button.module.scss";

const Button = (props) => {
  const className = useMemo(() => {
    if (props?.outline) {
      return styles.outlineButton;
    } else if (props?.disabled) {
      return styles.disabled
    } else {
      return styles.primaryButton;
    }
  }, [props?.outline]);

  return (
    <button
      {...props}
      disabled={props?.disabled}
      onClick={props?.onClick}
      className={`${styles.button} ${props?.className} ${className}`}
    >
      {props?.label}
    </button>
  );
};

export default Button;
